import * as leadStatusDivorce from "./divorce/leadStatus";
import * as leadStatusSettlement from "./settlement/leadStatus";
import * as leadStatusTraffic from "./traffic/leadStatus";
import * as leadStatusDocument from "./document/leadStatus";
import _get from "lodash/get";
import _includes from "lodash/includes";
import IconLaw from "../assets/icons/serviceOverview/IconCourtScales";
import IconCourtScales from "../assets/icons/serviceOverview/IconCourtScales";
import IconCalenderCheck from "../assets/icons/serviceOverview/IconCourt";
import IconCourt from "../assets/icons/serviceOverview/IconCourt";
import IconAssistent from "../assets/icons/serviceOverview/IconAssistant";
import iconAssistant from "../assets/icons/serviceOverview/IconAssistant";
import { getCaseLink, getProductData } from "./productService";
import { Link } from "react-router-dom";
import React from "react";
import { Button } from "@mui/material";
import { getStatusBoxConfigDivorce } from "./divorce/statusBoxSteps";
import { getStatusBoxConfigSettlement } from "./settlement/statusBoxSteps";
import { getStatusBoxConfigTraffic } from "./traffic/statusBoxSteps";
import { getStatusBoxConfigFamilyLawCase } from "./familyLaw/statusBoxSteps";
import { getStatusBoxConfigAlimony } from "./alimony/statusBoxSteps";
import { getStatusBoxConfigDeath } from "./death/statusBoxSteps";
import { getStatusBoxConfigContractLawCase } from "./contractLaw/statusBoxSteps";
import {
  getContractLawStatusBoxConfigAdvocardFlexService,
  getRentalContractStatusBoxConfigAdvocardFlexService,
} from "./contractLaw/flexService/statusBoxSteps";
import IconDocument from "../assets/icons/generic/IconDocument";
import iconDownload from "../assets/icons/serviceOverview/IconDocumentDownload";
import IconHints from "../assets/icons/serviceOverview/IconHints";
import _orderBy from "lodash/orderBy";
import _remove from "lodash/remove";
import { getStatusBoxConfigRentalContractCase } from "./rentalContract/statusBoxSteps";
import ReactGA from "react-ga4";
import { getStatusBoxConfigTrafficAccident } from "./trafficAccident/statusBoxSteps";
import { getStatusBoxConfigGeneralCivilLaw } from "./generalCivilLaw/statusBoxSteps";

export const getProcessConfig = (product) => {
  const formLink = (product) => {
    if (!product.id) {
      return "/servicewelt/" + getProductData(product.name, "urlPart") + "/antrag";
    }
    return getCaseLink(product) + "/antrag";
  };

  const contractLawDefaultConfig = {
    headline: "So einfach funktioniert es",
    steps: [
      {
        headline: "1. Fall schildern",
        content: "Sie beschreiben kurz Ihren Fall und laden Unterlagen zu Ihrem Vertrag hoch.",
        done: false,
        icon: IconDocument,
      },
      {
        headline: "2. Vorgehen festlegen",
        content: "Sie entscheiden sich, wie es weiter gehen soll und wir leiten alles in die Wege.",
        done: false,
        icon: IconLaw,
      },
      {
        headline: "3. Interessen durchsetzen",
        content: "Wir setzen uns schnell und professionell für Ihre rechtlichen Interessen ein.",
        done: false,
        icon: IconCourt,
      },
    ],
  };

  const processConfig = {
    divorce: {
      headline: "Ablauf",
      steps: [
        {
          headline: "1. Scheidungsantrag",
          content: (
            <>
              Sie füllen das {product.leadStatus < leadStatusDivorce.STATUS_DATA_COMPLETED ? <Link to={formLink(product)}>Formular</Link> : "Formular"} aus,
              erteilen die Vollmacht und wir erstellen den Scheidungsantrag für Sie.
            </>
          ),
          done: product.leadStatus > leadStatusDivorce.STATUS_DATA_COMPLETED,
          icon: IconDocument,
        },
        {
          headline: "2. Scheidung einreichen",
          content: "Wir reichen für Sie den Scheidungsantrag ein.",
          done: product.leadStatus > leadStatusDivorce.STATUS_PROCESS_PAID,
          icon: IconLaw,
        },
        {
          headline: "3. Scheidungstermin",
          content: "Das Gericht weist Ihnen einen Scheidungstermin zu und Sie werden geschieden.",
          done: product.leadStatus > leadStatusDivorce.STATUS_DIVORCE_DONE,
          icon: IconCalenderCheck,
        },
      ],
    },
    settlement: {
      headline: "Ablauf",
      steps: [
        {
          headline: "1. Kündigung prüfen lassen",
          content: (
            <>
              Sie füllen das <Link to={formLink(product)}>Formular</Link> aus, erteilen uns die Vollmacht und wir prüfen kostenlos Ihre Kündigung.
            </>
          ),
          done: product.leadStatus >= leadStatusSettlement.STATUS_POWER_OF_ATTORNEY_GRANTED,
          icon: IconDocument,
        },
        {
          headline: "2. Klage einreichen",
          content: "Rechtswidrige Kündigung? Dann reichen wir eine Kündigungsschutzklage für Sie ein.",
          done: product.leadStatus >= leadStatusSettlement.STATUS_SUBMITTED,
          icon: iconAssistant,
        },
        {
          headline: "3. Einigung oder Urteil",
          content: "Durch eine Einigung mit dem Arbeitgeber oder per Urteil, kommt es zur Entscheidung bezüglich Ihrer Klage.",
          done: product.leadStatus >= leadStatusSettlement.STATUS_DECISION_MADE,
          icon: IconCalenderCheck,
        },
      ],
    },
    traffic: {
      headline: "Zum Ablauf",
      steps: [
        {
          headline: "1. Bescheid prüfen lassen",
          content: (
            <>
              <Link to={formLink(product)}>Sie schildern hier kurz</Link>, was Ihnen vorgeworfen wird und Ihr Bescheid wird kostenlos geprüft
            </>
          ),
          done: product.leadStatus >= leadStatusTraffic.STATUS_DATA_COMPLETED,
          icon: IconDocument,
        },
        {
          headline: "2. Vorgehen besprechen",
          content: "Wir besprechen das weitere Vorgehen & Sie erteilen die Vollmacht",
          done: product.leadStatus >= leadStatusTraffic.STATUS_POWER_OF_ATTORNEY_GRANTED,
          icon: IconAssistent,
        },
        {
          headline: "3. Einigung oder Urteil",
          content: "Wir fordern Akteneinsicht an und leiten alle Schritte ein, um den Vorwurf abzuwenden",
          done: product.leadStatus >= leadStatusTraffic.STATUS_DECISION_MADE,
          icon: IconCalenderCheck,
        },
      ],
    },
    trafficAccident: {
      headline: "Zum Ablauf",
      steps: [
        {
          headline: "1. Fall schildern ",
          content: (
            <>
              <Link to={formLink(product)}>Sie beschreiben kurz</Link>, was bei Ihrem Verkehrsunfall geschehen ist und laden Unterlagen dazu hoch.
            </>
          ),
          done: product.leadStatus >= leadStatusTraffic.STATUS_DATA_COMPLETED,
          icon: IconDocument,
        },
        {
          headline: "2. Vorgehen besprechen",
          content: "Wir setzen uns mit dem KFZ-Haftpflichtversicherer Ihres Unfallgegners in Verbindung und stimmen mit Ihnen das weitere Vorgehen ab.",
          done: product.leadStatus >= leadStatusTraffic.STATUS_POWER_OF_ATTORNEY_GRANTED,
          icon: IconCourtScales,
        },
        {
          headline: "3. Einigung oder Urteil",
          content: "Wir setzen uns schnell und professionell für die Durchsetzung Ihrer Ansprüche ein.",
          done: product.leadStatus >= leadStatusTraffic.STATUS_DECISION_MADE,
          icon: IconCourt,
        },
      ],
    },
    familyLawCase: {
      headline: "Erstberatung vereinbaren",
      steps: [
        {
          headline: "1. Kurz Frage schildern",
          content: "Sie beschreiben kurz Ihr Anliegen, damit wir Ihnen bestmöglich helfen können.",
          done: false,
          icon: IconDocument,
        },
        {
          headline: "2. Erstgespräch vereinbaren",
          content: "Sie vereinbaren einen Termin für ein Erstgespräch.",
          done: false,
          icon: IconAssistent,
        },
        {
          headline: "3. Weiteres Vorgehen",
          content: "Wir besprechen Ihre Möglichkeiten und Sie entscheiden sich, wie Sie weiter vorgehen möchten.",
          done: false,
          icon: IconHints,
        },
      ],
    },
    contractLaw: contractLawDefaultConfig,
    eventContract: contractLawDefaultConfig,
    membershipContract: contractLawDefaultConfig,
    otherContract: contractLawDefaultConfig,
    providerContract: contractLawDefaultConfig,
    purchaseContract: contractLawDefaultConfig,
    serviceContract: contractLawDefaultConfig,
    subscriptionContract: contractLawDefaultConfig,
    travelContract: contractLawDefaultConfig,
    dataLeakContract: {
      headline: "So einfach funktioniert es",
      steps: [
        {
          headline: "1. Fall schildern",
          content: "Sie beschreiben kurz Ihren Fall und laden Unterlagen zu Ihrem Vertrag hoch.",
          done: false,
          icon: IconDocument,
        },
        {
          headline: "2. SCHUFA-Anfrage",
          content: "Wir fordern eine SCHUFA / CRIF-Auskunft für dich an und prüfen, ob der Mobilfunkanbieter deine Daten weitergegeben hat.",
          done: false,
          icon: IconLaw,
        },
        {
          headline: "3. Schadensersatz einfordern",
          content: "Es wurden Daten weitergegeben? Dann fordern wir Schadensersatz für Sie ein!",
          done: false,
          icon: IconCourt,
        },
      ],
    },
    vehicleContract: contractLawDefaultConfig,
    alimony: {
      headline: "Meine Analyse",
      steps: [
        {
          headline: "1. Situation schildern",
          content: "Machen Sie ganz einfach alle Angaben zu Ihrer Situation.",
          done: product.leadStatus >= leadStatusDocument.STATUS_DATA_COMPLETED,
          icon: IconDocument,
        },
        {
          headline: "2. Analyse und Berechnung erhalten",
          content: "Sie können Ihre Analyse jederzeit einsehen und herunterladen.",
          done: product.leadStatus >= leadStatusDocument.STATUS_COMPLETED,
          icon: iconDownload,
        },
        {
          headline: "3. Offene Fragen?",
          content: "Nutzen sie einfach den Link in Ihrer Analyse, um ein Erstgespräch zum Thema Unterhalt zu vereinbaren.",
          done: false,
          icon: IconHints,
        },
      ],
    },
    death: {
      headline: "Mein persönlicher Ratgeber",
      steps: [
        {
          headline: "1. Situation schildern",
          content: "Schildern Sie kurz Ihre Situation und Fragen",
          done: product.leadStatus >= leadStatusDocument.STATUS_DATA_COMPLETED,
          icon: IconDocument,
        },
        {
          headline: "2. Ratgeber erhalten",
          content: "Sie können Ihren persönlichen Ratgeber jederzeit einsehen und herunterladen.",
          done: product.leadStatus >= leadStatusDocument.STATUS_COMPLETED,
          icon: iconDownload,
        },
        {
          headline: "3. Offene Fragen?",
          content: "Dann können Sie gerne über den Link in Ihrem Ratgeber ein Erstgespräch vereinbaren",
          done: false,
          icon: IconHints,
        },
      ],
    },
    rentalContract: {
      headline: "So einfach funktioniert es",
      steps: [
        {
          headline: "1. Fall schildern",
          content: "Sie beschreiben kurz Ihren Fall und laden Unterlagen zu Ihrem Mietvertrag hoch.",
          done: false,
          icon: IconDocument,
        },
        {
          headline: "2. Vorgehen festlegen",
          content: "Sie entscheiden sich, wie es weiter gehen soll und wir leiten alles in die Wege.",
          done: false,
          icon: iconDownload,
        },
        {
          headline: "3. Interessen durchsetzen",
          content: "Wir setzen uns schnell und professionell für Ihre rechtlichen Interessen ein.",
          done: false,
          icon: IconHints,
        },
      ],
    },
    generalCivilLaw: {
      headline: "So einfach funktioniert es",
      steps: [
        {
          headline: "1. Fall schildern",
          content: "Sie beschreiben kurz Ihren Fall und laden gegebenenfalls Unterlagen hoch.",
          done: false,
          icon: IconDocument,
        },
        {
          headline: "2. Vorgehen festlegen",
          content: "Sie entscheiden sich, wie es weiter gehen soll und wir leiten alles in die Wege.",
          done: false,
          icon: IconLaw,
        },
        {
          headline: "3. Interessen durchsetzen",
          content: "Wir setzen uns schnell und professionell für Ihre rechtlichen Interessen ein.",
          done: false,
          icon: IconCourt,
        },
      ],
    },
    default: null,
  };
  return _get(processConfig, product.productCategory === "contractLaw" ? product.productCategory : product.name);
};

export const getStatusBoxConfig = (product) => {
  let statusBoxConfig = {
    header: "Es ist ein Fehler aufgetreten",
    text: "",
    ctaButton: null,
    productName: "",
    percentage: 100,
    onClick: () => {},
  };

  let buttonTarget = "/";
  let buttonLabel = "";

  if (product.productCategory === "contractLaw") {
    if (product.insurance.specialTermsTag === "advocardFlex") {
      return getContractLawStatusBoxConfigAdvocardFlexService(product);
    }

    return getStatusBoxConfigContractLawCase(product);
  }

  switch (product.name) {
    case "divorce":
      return getStatusBoxConfigDivorce(product);
    case "settlement":
      return getStatusBoxConfigSettlement(product);
    case "traffic":
      return getStatusBoxConfigTraffic(product);
    case "familyLawCase":
      return getStatusBoxConfigFamilyLawCase(product);
    case "alimony":
      return getStatusBoxConfigAlimony(product);
    case "death":
      return getStatusBoxConfigDeath(product);
    case "rentalContract":
      if (product.insurance.specialTermsTag === "advocardFlex") {
        return getRentalContractStatusBoxConfigAdvocardFlexService(product);
      }

      return getStatusBoxConfigRentalContractCase(product);
    case "trafficAccident":
      return getStatusBoxConfigTrafficAccident(product);
    case "generalCivilLaw":
      return getStatusBoxConfigGeneralCivilLaw(product);
    default:
      break;
  }

  statusBoxConfig.ctaButton = (
    <Button component={Link} to={buttonTarget} variant="contained" color="primary" fullWidth onClick={statusBoxConfig.onClick}>
      {buttonLabel}
    </Button>
  );

  return statusBoxConfig;
};

export const getAppointmentDisplayType = (product) => {
  const lawyerCounselingCallStatus = _get(product, "lawyerCounselingCall.status");
  const advisoryAppointmentStatus = _get(product, "advisoryAppointment.status");

  //if theres an open appointment. only works while created is the only "open" status
  if (lawyerCounselingCallStatus === "created" || advisoryAppointmentStatus === "created") {
    return "appointments";
  }

  if (
    //is advisory product
    (_includes(["death", "alimony", "familyLawCase"], product.name) || (product.productCategory === "contractLaw" && product.caseCategory === "advisory")) &&
    //and has both appointments completed
    advisoryAppointmentStatus === "processed" &&
    lawyerCounselingCallStatus === "processed"
  ) {
    return "limitReached";
  }

  return "bookingWidget";
};

export const splitUpByCompletedStatus = (minimalCases) => {
  let cases = _orderBy(minimalCases, ["created"], ["desc"]);
  let closedCases = _remove(cases, (minimalCase) => minimalCase.isCompleted || minimalCase.backofficeCase.won || minimalCase.backofficeCase.lost);
  return { cases, closedCases };
};

export const handleThemeSwitch = async (event, updateMutation, refreshCustomer, customer, setIsLoading) => {
  if (!customer?.userConfig?.id) {
    return;
  }
  setIsLoading(true);

  const currentTheme = customer.userConfig.theme;
  const newTheme = currentTheme === "dark" ? "light" : "dark";

  await updateMutation.mutateAsync({
    uri: "/user_configs",
    id: customer.userConfig.id,
    data: {
      theme: newTheme,
    },
  });
  ReactGA.event({
    category: "Theme",
    action: "Toggle to " + newTheme.toUpperCase() + " Mode",
    nonInteraction: false,
  });
  await refreshCustomer();
  setIsLoading(false);
};
